import Auth from '../services/auth';
import i18n from 'roddeh-i18n';
const getVisibleSubItemsValue = () => {
    let visibleSubItems = 0;
    if (typeof window.__STATE__ !== 'undefined') {
        visibleSubItems = window.__STATE__.functions.top_menu_visible_sub_items;
    }
    return visibleSubItems;
};
const hideItemsInColumn = (items, visibleSubItems) => {
    if (items.length <= visibleSubItems) {
        return;
    }
    // Ukrywamy elementy, które nie mieszczą się w widoku
    for (let i = visibleSubItems; i < items.length; i++) {
        items[i].classList.add('hidden');
    }
};
const getSubItems = (column) => {
    const subItems = column.querySelectorAll('li:not(.show-more):not(.show-less)');
    return Array.from(subItems);
};
const applyShowMore = (visibleSubItems) => {
    const topMenuColumns = document.querySelectorAll('.top-menu > ul > li > div .link-cols div ul');
    if (visibleSubItems === 0) {
        return;
    }
    topMenuColumns.forEach((column) => {
        const subItems = getSubItems(column);
        if (subItems.length <= visibleSubItems) {
            return;
        }
        // Ukrywamy elementy, listy które wykraczają poza maksymalną ilość elementów
        hideItemsInColumn(subItems, visibleSubItems);
        const showMore = document.createElement('li');
        showMore.classList.add('show-more');
        showMore.innerHTML = `<a class="show-more-less" href="#">${i18n('Show more')}</a>`;
        column.appendChild(showMore);
        const showLess = document.createElement('li');
        showLess.classList.add('show-less');
        showLess.style.display = 'none';
        showLess.innerHTML = `<a class="show-more-less" href="#">${i18n('Show less')}</a>`;
        column.appendChild(showLess);
        const showMoreLink = showMore.querySelector('a');
        if (showMoreLink) {
            showMoreLink.addEventListener('click', (e) => {
                e.preventDefault();
                const subItems = getSubItems(column);
                subItems.forEach((item) => {
                    item.classList.remove('hidden');
                });
                showMore.style.display = 'none';
                showLess.style.display = 'block';
            });
        }
        const showLessLink = showLess.querySelector('a');
        if (showLessLink) {
            showLessLink.addEventListener('click', (e) => {
                e.preventDefault();
                const subItems = getSubItems(column);
                hideItemsInColumn(subItems, visibleSubItems);
                showMore.style.display = 'block';
                showLess.style.display = 'none';
            });
        }
    });
};
export default () => {
    const menuOverlay = document.querySelector('#menuOverlay');
    const visibleSubItems = getVisibleSubItemsValue();
    applyShowMore(visibleSubItems);
    const setOverflowHidden = () => {
        const hamburgerMenuCheckbox = document.querySelector('.hamburger-menu > input[type="checkbox"]');
        const body = document.querySelector('body');
        if (!body || !hamburgerMenuCheckbox) {
            return;
        }
        if (hamburgerMenuCheckbox.checked) {
            body.style.overflow = 'hidden';
        }
    };
    const closeAllFirstLevel = () => {
        const elements = document.querySelectorAll('.top-menu > ul > li > .first-level-wrapper');
        elements.forEach((a) => {
            a.classList.remove('visible');
        });
    };
    const closeAllThirdLevel = () => {
        document
            .querySelectorAll('.always-mobile.link-cols .link-cols-child .third-level-title')
            .forEach((a) => {
            a.classList.remove('open');
        });
        document.querySelectorAll('.always-mobile.link-cols .link-cols-child .has-title').forEach((a) => {
            a.style.maxHeight = '0';
            a.classList.remove('open');
            const aParent = a.parentElement;
            if (!aParent) {
                return;
            }
            aParent.classList.remove('open');
        });
    };
    const closeAllSecondLevel = () => {
        document.querySelectorAll('.always-mobile.link-cols .link-cols-child').forEach((a) => {
            a.classList.remove('expanded');
        });
    };
    const toggleSecondLevelMenu = (childMenu) => {
        if (childMenu.classList.contains('expanded')) {
            childMenu.classList.remove('expanded');
            childMenu.classList.add('collapsing');
        }
        else {
            setOverflowHidden();
            childMenu.classList.add('expanded');
            childMenu.classList.remove('collapsing');
        }
    };
    const toggleThirdLevelMenu = (menu, link) => {
        const menuClasses = menu.classList;
        if (!menuClasses.contains('open')) {
            closeAllThirdLevel();
            setOverflowHidden();
            menu.style.maxHeight = menu.scrollHeight + 'px';
            menu.classList.add('open');
            link.classList.add('open');
        }
        else {
            menu.style.maxHeight = '0';
            menu.classList.remove('open');
            link.classList.remove('open');
        }
    };
    // wykrywamy kliknięcia poza nav.top-menu i zamykamy menu
    document.addEventListener('click', (e) => {
        if (!(e.target instanceof HTMLElement)) {
            return;
        }
        if (e.target.closest('.top-menu') !== null) {
            return;
        }
        closeAllFirstLevel();
        if (menuOverlay) {
            menuOverlay.classList.remove('active');
        }
    });
    // nasłuchujemy kliknięcia na przyciski zamykające menu w wersji desktop
    const closeBtns = document.querySelectorAll('.top-menu .first-level-wrapper .close-btn');
    closeBtns.forEach((closeBtn) => {
        closeBtn.addEventListener('click', () => {
            closeAllFirstLevel();
            if (menuOverlay) {
                menuOverlay.classList.remove('active');
            }
        });
    });
    document.querySelectorAll('nav.top-menu > ul > li > a').forEach((a) => {
        const parent = a.parentElement;
        if (!parent) {
            return;
        }
        // Pobieramy pierwsze dziecki div.
        const div = parent.querySelector('.first-level-wrapper');
        if (!div) {
            return;
        }
        let timeout;
        let timeoutClose;
        // nasłuchujemy eventu mouseenter. Do diva dodajemy klasę visible po krótkim opóźnieniu (300ms)
        a.addEventListener('mouseenter', () => {
            timeout = setTimeout(() => {
                closeAllFirstLevel();
                div.classList.add('visible');
                if (menuOverlay) {
                    menuOverlay.classList.add('active');
                }
            }, 300);
        });
        a.addEventListener('mouseleave', () => {
            clearTimeout(timeout);
        });
        const navElement = a.closest('.top-menu');
        if (navElement) {
            navElement.addEventListener('mouseenter', () => {
                clearTimeout(timeoutClose);
            });
            // czyścimy timeout otwierajacy menu jeśli kursor opuścił element
            navElement.addEventListener('mouseleave', () => {
                // zamykamy menu jeśli jest otwarte i mineło 300ms od wyjecahnia kursora z elementu
                timeoutClose = setTimeout(() => {
                    closeAllFirstLevel();
                    div.classList.remove('visible');
                    if (menuOverlay) {
                        menuOverlay.classList.remove('active');
                    }
                }, 250);
            });
        }
    });
    // otwieranie menu drugiego poziomu
    document.querySelectorAll('.always-mobile.link-cols .link-cols-parent').forEach((a) => {
        a.addEventListener('click', (e) => {
            const parent = a.parentElement;
            if (!parent) {
                return;
            }
            const linkColsChild = parent.querySelector('.link-cols-child');
            if (linkColsChild) {
                e.preventDefault();
                toggleSecondLevelMenu(linkColsChild);
            }
        });
    });
    // MOBILE: event nasłuchujący zakończenie animacji zamykania drugiego poziomu menu
    document.querySelectorAll('.always-mobile.link-cols .link-cols-child').forEach((a) => {
        a.addEventListener('animationend', (e) => {
            if (e.animationName === 'moveOutOfViewPort') {
                a.classList.remove('collapsing');
            }
        });
    });
    // MOBILE: listener umożliwiajacy powrót z menu drugiego poziomu do menu pierwszego poziomu
    document
        .querySelectorAll('.always-mobile.link-cols .link-cols-child .link-cols-child__header-back, .always-mobile.link-cols .link-cols-child .link-cols-child__header-title')
        .forEach((a) => {
        a.addEventListener('click', () => {
            const childMenu = a.closest('.link-cols-child');
            if (!childMenu) {
                return;
            }
            closeAllThirdLevel();
            toggleSecondLevelMenu(childMenu);
        });
    });
    // MOBILE: listener otiwerajacy/zamykający menu trzeciego poziomu
    document
        .querySelectorAll('.always-mobile.link-cols .link-cols-child .third-level-title:not(.without-children)')
        .forEach((a) => {
        a.addEventListener('click', (e) => {
            e.preventDefault();
            const sibling = a.nextElementSibling;
            if (!sibling || !sibling.classList.contains('has-title')) {
                return;
            }
            toggleThirdLevelMenu(sibling, a);
        });
    });
    // MOBILE: wykonujemy akcje chowania podmenu drugiego i trzeciego poziomu w przypadku gdy uzytkownik zamknie menu uzywając hamburgera
    // dzięki temu po ponownym otwarciu otrzymamy widok menu w zerowym ustawieniu
    const hamburgerMenuCheckbox = document.querySelector('.hamburger-menu > input[type="checkbox"]');
    if (hamburgerMenuCheckbox) {
        hamburgerMenuCheckbox.addEventListener('change', () => {
            const body = document.querySelector('body');
            if (!body) {
                return false;
            }
            if (!hamburgerMenuCheckbox.checked) {
                // Zamykamy kolejne poziomy menu po 300ms aby animacja odbyło się to dopiero po zamknięciu całego menu
                setTimeout(() => {
                    closeAllThirdLevel();
                    closeAllSecondLevel();
                }, 300);
                body.style.overflow = '';
            }
            else {
                body.style.overflow = 'hidden';
            }
            const visible = hamburgerMenuCheckbox.checked;
            const event = new CustomEvent('toggle-mobile-top-menu', {
                detail: { visible },
                bubbles: true,
            });
            window.dispatchEvent(event);
        });
        const closeInsideMenu = document.querySelector('.always-mobile.link-cols .menu-control .close');
        if (closeInsideMenu) {
            closeInsideMenu.addEventListener('click', () => {
                hamburgerMenuCheckbox.checked = false;
                const event = new Event('change');
                hamburgerMenuCheckbox.dispatchEvent(event);
            });
        }
        // Mobile: listener umożliwiajacy zamknięcie menu z zagnieżdzonego poziomu
        document.querySelectorAll('.link-cols-child__header-close').forEach((close) => {
            close.addEventListener('click', (e) => {
                e.preventDefault();
                hamburgerMenuCheckbox.checked = false;
                //trigerujemy event change
                const event = new Event('change');
                hamburgerMenuCheckbox.dispatchEvent(event);
            });
        });
    }
    const isLoggedIn = () => {
        const state = Auth.getLastState();
        if (state === null) {
            return false;
        }
        return state.loggedIn;
    };
    const checkAuthStateChange = () => {
        const loginButton = document.querySelector('.hamburger-menu .always-mobile.link-cols .login-link');
        const logoutButton = document.querySelector('.hamburger-menu .always-mobile.link-cols .logout-link');
        if (logoutButton && loginButton) {
            if (isLoggedIn()) {
                loginButton.style.display = 'none';
                logoutButton.style.display = 'block';
            }
            else {
                loginButton.style.display = 'block';
                logoutButton.style.display = 'none';
            }
        }
        const aboveLogged = document.querySelector('.above-header-block--logged');
        const aboveUnlogged = document.querySelector('.above-header-block--unlogged');
        if (isLoggedIn()) {
            if (aboveLogged) {
                aboveLogged.style.display = 'block';
            }
            if (aboveUnlogged) {
                aboveUnlogged.style.display = 'none';
            }
        }
        else {
            if (aboveUnlogged) {
                aboveUnlogged.style.display = 'block';
            }
            if (aboveLogged) {
                aboveLogged.style.display = 'none';
            }
        }
    };
    checkAuthStateChange();
    Auth.addListener(() => {
        checkAuthStateChange();
    });
    window.addEventListener('toggle-mobile-search', () => {
        const hamburgerMenuCheckbox = document.querySelector('.hamburger-menu > input[type="checkbox"]');
        if (!hamburgerMenuCheckbox) {
            return;
        }
        if (hamburgerMenuCheckbox.checked) {
            hamburgerMenuCheckbox.checked = false;
            const event = new Event('change');
            hamburgerMenuCheckbox.dispatchEvent(event);
        }
    });
    const floatingButton = document.querySelector('.floating-button.js-btn-filter');
    if (floatingButton) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    floatingButton.classList.add('hidden');
                }
                else {
                    floatingButton.classList.remove('hidden');
                }
            });
        }, {
            threshold: [0.5],
        });
        const filterButton = document.querySelector('.filter__button.js-btn-filter');
        if (filterButton) {
            observer.observe(filterButton);
        }
    }
};
